import {useSuspenseQuery} from '@tanstack/react-query';
import {tagSchema} from 'shared';

import {api} from '@/lib/ky';

import {tagKeys} from './queryKeys';

import type {
  QueryConfig,
  ExtractFnReturnType,
  QueryConfig2,
} from '@/lib/react-query';

export const getTag = async (id: string) => {
  const data = await api.get(`tags/${id}`).json();
  return tagSchema.parse(data);
};

export const useTag = (id: string, config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: tagKeys.detail(id),
    queryFn: () => getTag(id),
  });
};
export const useTagLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getTag;
